/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from '@gasbuddy/react';
import styles from './styles.css';
import sharedStyles from '../../styles/shared.css';
import Chevron from '../chevron';
import ListSelectWrapper from '../list-select-wrapper';
import { setLoading } from '../../actions';

const {
  api,
  store,
  getCurrentAppOrganizations,
  saveUserOrganization,
  setOrganizationForSession,
  setEmergencyStatus,
} = require('../../../lib/bputils').default;

class OrganizationSelector extends React.Component {
  static propTypes = {
    dispatchSetLoading: PropTypes.func,
  };

  static defaultProps = {
    dispatchSetLoading: null,
  };

  constructor(props) {
    super(props);

    this.state = {
      organizations: null,
      selectedOrg: null,
      isOpen: false,
    };

    this.orgSelectClicked = this.orgSelectClicked.bind(this);
    this.setOrgSelectorRef = this.setOrgSelectorRef.bind(this);
    this.setClose = this.setClose.bind(this);
    this.globalOnClickHandle = this.globalOnClickHandle.bind(this);
    this.handleOrgChange = this.handleOrgChange.bind(this);
  }

  componentDidMount = () => {
    this.loadOrganizations(true);
    window.addEventListener('mousedown', this.globalOnClickHandle, false);
  }

  static getLogoUrl(url) {
    if (url) {
      return url;
    }
    return '/images/app/icon_generic-org-avatar.svg';
  }

  static getOrgOptions(organizations) {
    const options = [];
    if (organizations) {
      organizations.forEach((org) => {
        options.push(
          <option
            value={org.organization_id}
            key={org.organization_id}
            img={OrganizationSelector.getLogoUrl(org.logo_url)}
          >
            {org.display_name}
          </option>,
        );
      });
    }

    return options;
  }

  setClose() {
    this.setState({ isOpen: false });
  }

  setOrgSelectorRef(node) {
    this.orgSelectorRef = node;
  }

  orgSelectClicked() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  loadOrganizations(retry) {
    const self = this;

    api.get({
      path: '/organizations',
      requestId: 'loadAvailableOrganizations',
      error() {
        if (retry) {
          self.loadOrganizations(false);
        }
      },
      success({ emergency_status: emergencyStatus, organizations: orgs }) {
        const currentOrgId = store.get('current_org_id');
        const currentAppOrgs = getCurrentAppOrganizations(orgs);
        const orderedAppOrgs = _.sortBy(currentAppOrgs, ['display_name']);
        const orgOptions = OrganizationSelector.getOrgOptions(orderedAppOrgs);
        const selectedOrg = orderedAppOrgs.find(o => o.organization_id === currentOrgId);
        saveUserOrganization(selectedOrg);
        setEmergencyStatus(emergencyStatus);
        self.setState(() => ({
          organizations: orderedAppOrgs, orgOptions, selectedOrg,
        }));
      },
    });
  }

  handleOrgChange(selectedOrgId) {
    const { organizations, selectedOrg } = this.state;

    if (selectedOrg.organization_id !== selectedOrgId) {
      if (organizations && organizations.length) {
        const newOrg = organizations.find(org => org.organization_id === selectedOrgId);
        if (newOrg) {
          this.setState({ selectedOrg: newOrg });
          this.props.dispatchSetLoading(true);

          setOrganizationForSession(selectedOrgId, (err) => { throw err; });
        }
      }
    }
  }

  globalOnClickHandle(e) {
    const { isOpen } = this.state;
    if (isOpen && !this.orgSelectorRef.contains(e.target)) {
      this.setClose();
    }
  }

  render() {
    const { organizations, selectedOrg, isOpen } = this.state;
    const isLoading = !organizations;

    let orgOptions = [];

    const isSingleOrg = organizations && organizations.length === 1;
    if (!isLoading && !isSingleOrg) {
      orgOptions = OrganizationSelector.getOrgOptions(organizations);
    }

    return (
      <div
        ref={this.setOrgSelectorRef}
        className={` ${styles.orgSelector} ${isSingleOrg ? styles.singleOrg : ''} ${isOpen ? styles.opened : ''}`}
      >
        {
          isLoading
            ? <span style={{ lineHeight: '30px' }}>Loading</span>
            : (
              <div className={styles.orgDropdownBtn} onClick={isSingleOrg ? undefined : this.orgSelectClicked}>
                <div className={styles.orgLabel}>
                  <img src={OrganizationSelector.getLogoUrl(selectedOrg.logo_url)} alt={`${selectedOrg.display_name}'s logo`} />
                  <span className={styles.labelText}>{selectedOrg.display_name}</span>
                </div>
                {!isSingleOrg
                  ? (
                    <div className={`${styles.chevronContainer} ${sharedStyles.pullRight}`}>
                      <Chevron direction={(isOpen ? 'up' : 'down')} size={13} left={(isOpen ? -2 : 0)} top={(isOpen ? 12 : 5)} width={2} />
                    </div>
                  ) : ''
                }
              </div>
            )
        }
        {
          (!isLoading && !isSingleOrg && isOpen)
            ? (
              <ListSelectWrapper
                onChangeCallback={this.handleOrgChange}
                options={orgOptions}
                selectedItemId={selectedOrg.organization_id}
                isOpen={isOpen}
                onCloseCallback={this.setClose}
                searchable
                searchPlaceholder="Search Organizations"
              />
            )
            : ''
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSetLoading: loading => dispatch(setLoading(loading)),
});

export default connect(null, mapDispatchToProps)(OrganizationSelector);
